import { useMemberDetails } from "./member-details";

export async function doPost(url, model) {
  return doRequest(url, model, "POST");
}

export async function doPatch(url, model) {
  return doRequest(url, model, "PATCH");
}

export async function doGet(url, model) {
  return doRequest(url, model, "GET");
}

async function doRequest(url, model, method) {
  if (process.env.NODE_ENV === "development") return doDev(url, model, method);

  const resp = await fetch(`/register/api/${url}`.replace("//", "/"), {
    method,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: model ? JSON.stringify(model) : void 0,
  });

  return resp.json();
}

function doDev(url, model, method) {
  const { membershipStatusType } = useMemberDetails();
  const response = {
    success: true,
  };

  if (/submit/.test(url)) response.paymentUrl = "some-url";
  else if (/education/.test(url)) {
    if (["APR", "STU"].includes(membershipStatusType.value)) {
      if (membershipStatusType.value === "APR") {
        response.status = "APR";
      } else {
        response.status = "STU";
      }
    } else response.status = membershipStatusType.value;
  } else if (/findmembership/.test(url))
    response.data = {
      isExpired: false,
      type: "MEM",
      status: "LIF",
    };

  console.log(url, model, method, response);
  return new Promise((res) => {
    setTimeout(() => res(response), 2000);
  });
}
